import { z } from 'zod'
import { Address, IdempotencyKey, WeiString } from '../primitives.js'
import { ProposalKind, QuoteSource } from '../enums.js'
import { Quote, Proposal, PolicyVerdict, Execution } from './trading-decisions.js'
import { ArbRef } from './accounts.js'

export * from './trading-decisions.js'
export * from './accounts.js'

// Agent proposals ----------------------------------------------------------------

export const CreateProposal = z.object({
  idempotencyKey: IdempotencyKey,
  /** The customer-signed permission the proposal trades under (`GET /agent/permissions`). */
  permissionRef: ArbRef,
  kind: ProposalKind,
  tokenIn: Address,
  tokenOut: Address,
  amountIn: WeiString,
  rationale: z.string().min(1).max(4000),
  quote: Quote.optional(),
  quoteSource: QuoteSource.optional(),
})
export type CreateProposal = z.input<typeof CreateProposal>

export const ProposalDetail = z.object({
  proposal: Proposal,
  verdict: PolicyVerdict.nullable(),
  execution: Execution.nullable(),
})
export type ProposalDetail = z.output<typeof ProposalDetail>
